import app from "@/common/plugins/vueInstance";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

app.component("QuillEditor", QuillEditor);
